import React from "react";
import { Helmet } from "react-helmet-async";

const SeoHelmet = ({
  title, // Fallback for pages like blog that have a main title
  metaTitle,
  metaDescription,
  metaKeywords,
  index,
  follow,
  ogTitle,
  ogDescription,
  ogImage,
  ogUrl,
  ogType,
  twitterTitle,
  twitterDescription,
  twitterImage,
  twitterCard,
  scheme,
}) => {
  // Cascading fallbacks: Twitter -> OG -> Meta -> Base
  const finalTitle = metaTitle || title;
  const finalOgTitle = ogTitle || finalTitle;
  const finalTwitterTitle = twitterTitle || finalOgTitle;

  const finalMetaDesc = metaDescription;
  const finalOgDesc = ogDescription || finalMetaDesc;
  const finalTwitterDesc = twitterDescription || finalOgDesc;

  const finalTwitterImage = twitterImage || ogImage;

  // Dynamic robots tag
  let robotsContent = undefined;
  if (index !== undefined && follow !== undefined) {
    robotsContent = `${index ? "index" : "noindex"}, ${follow ? "follow" : "nofollow"}`;
  }

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      {finalTitle && <title>{finalTitle}</title>}
      {finalMetaDesc && <meta name="description" content={finalMetaDesc} />}
      {metaKeywords && <meta name="keywords" content={metaKeywords} />}
      {robotsContent && <meta name="robots" content={robotsContent} />}

      {/* Open Graph */}
      {finalOgTitle && <meta property="og:title" content={finalOgTitle} />}
      {finalOgDesc && <meta property="og:description" content={finalOgDesc} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      {ogUrl && <meta property="og:url" content={ogUrl} />}
      {ogType && <meta property="og:type" content={ogType} />}

      {/* Twitter */}
      {twitterCard && <meta name="twitter:card" content={twitterCard} />}
      {finalTwitterTitle && (
        <meta name="twitter:title" content={finalTwitterTitle} />
      )}
      {finalTwitterDesc && (
        <meta name="twitter:description" content={finalTwitterDesc} />
      )}
      {finalTwitterImage && (
        <meta name="twitter:image" content={finalTwitterImage} />
      )}

      {/* JSON-LD Schema */}
      {scheme && Object.keys(scheme).length > 0 && (
        <script type="application/ld+json">{JSON.stringify(scheme)}</script>
      )}
    </Helmet>
  );
};

export default SeoHelmet;
